
import type { PropType } from 'vue'
import { computed, defineComponent } from 'vue'
import { ColorEnum } from '../../enums'
import { ArrayUtils } from '../../utils/array.utils'
import { UiCheckbox, UiRadio } from '../keen-ui'
import { EpbBadge } from './epb-badge'
import { EpbButton } from './epb-button'
import { EpbText } from './epb-text'

export interface EpbSelectPanelOption {
  value: string | number
  label?: string
  tooltip?: string
}

export default defineComponent({
  name: 'EpbSelectPanel',
  components: {
    EpbBadge,
    EpbButton,
    EpbText,
    UiCheckbox,
    UiRadio,
  },
  props: {
    options: {
      type: Array as PropType<Array<EpbSelectPanelOption>>,
      required: true,
    },
    value: {
      type: [String, Number, Array] as PropType<string | number | Array<string | number>>,
      default: () => [],
    },
    label: String,
    action: String,
  },
  setup(props) {
    const baseClass = 'epb-select-panel'

    const isMultiple = computed<boolean>(() => Array.isArray(props.value))

    return {
      baseClass,
      isMultiple,
      ColorEnum,
      ArrayUtils,
    }
  },
})
